import React from 'react';
import classes from './Message.css';

const Message = ({ type, children }) => {
  const messageClasses = [classes.Message, classes[type]].join(' ');
  return (
    <div className={messageClasses}>
      {children}
    </div>
  );
};

export default Message;